import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const alertDialogDefaultVariants = {
  "success": "confirm"
}
const alertDialogCompoundVariants = []

const alertDialogSlotNames = [
  [
    "root",
    "alert-dialog__root"
  ],
  [
    "wrapper",
    "alert-dialog__wrapper"
  ],
  [
    "actions",
    "alert-dialog__actions"
  ]
]
const alertDialogSlotFns = /* @__PURE__ */ alertDialogSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, alertDialogDefaultVariants, getSlotCompoundVariant(alertDialogCompoundVariants, slotName))])

const alertDialogFn = memo((props = {}) => {
  return Object.fromEntries(alertDialogSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const alertDialogVariantKeys = [
  "success"
]
const getVariantProps = (variants) => ({ ...alertDialogDefaultVariants, ...compact(variants) })

export const alertDialog = /* @__PURE__ */ Object.assign(alertDialogFn, {
  __recipe__: false,
  __name__: 'alertDialog',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: alertDialogVariantKeys,
  variantMap: {
  "success": [
    "fatal",
    "error",
    "warning",
    "confirm",
    "success"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, alertDialogVariantKeys)
  },
  getVariantProps
})